import React from "react";
import styles from "./index.module.css";
import TopNavigation from "../layout/components/TopNavigation";
import Footer from "../layout/components/FooterSection";
import PcFullSet from "./pcFullSet";

const Hardware = () => {
  return (
    <div className={styles.page}>
      <TopNavigation />
      <PcFullSet />
      <Footer />
    </div>
  );
};

export default Hardware;
